import useGetPrice from './useGetPrice';
import useGetImage from './useGetImage';
import useGetTitle from './useGetTitle';
import useGetDescription from './useGetDescription';
import useGetLink from './useGetLink';
import useGetStatus from './useGetStatus';
import useGetOnlyDescription from './useGetOnlyDescription';

export default function useGetInfo() {
  if (!arguments[0]) return null;

  const { oldPrice, newPrice } = useGetPrice(arguments[0]);
  const status = useGetStatus(arguments[0]);
  const image = useGetImage(arguments[0]);
  const title = useGetTitle(arguments[0]);
  const descriptionWithBrand = useGetDescription(arguments[0]);
  const link = useGetLink(arguments[0]);
  const descriptionWithoutBrand = useGetOnlyDescription(arguments[0]);

  return {
    oldPrice,
    newPrice,
    title,
    description: descriptionWithBrand,
    status,
    link,
    image,
    onlyDescription: descriptionWithoutBrand,
  };
}
